import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-system",
  "use": "icon-system-usage",
  "viewBox": "0 0 70.5 65",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 70.5 65\" id=\"icon-system\">\n<style type=\"text/css\">\n</style>\n<path class=\"st0\" d=\"M62.4,55.2H7.9c-4.3,0-7.7-3.5-7.7-7.8V7.9c0-4.3,3.5-7.7,7.7-7.8h54.5c4.3,0,7.7,3.5,7.8,7.8v39.5\n\tC70.2,51.7,66.7,55.2,62.4,55.2z M7.9,5.2c-1.5,0-2.7,1.2-2.7,2.8v39.5c0,1.5,1.2,2.8,2.7,2.8h0h54.5c1.5,0,2.8-1.2,2.8-2.7v0V7.9\n\tc0-1.5-1.2-2.8-2.8-2.8l0,0H7.9z\" />\n<path class=\"st0\" d=\"M32.6,55h5v5.4h-5V55z\" />\n<path class=\"st0\" d=\"M17.8,59.9h35c1.7,0,2.5,0.8,2.5,2.5l0,0c0,1.7-0.8,2.5-2.5,2.5h-35c-1.7,0-2.5-0.8-2.5-2.5l0,0\n\tC15.3,60.7,16.1,59.9,17.8,59.9z\" />\n<path class=\"st0\" d=\"M4.6,40.3h61.7c1.7,0,2.5,0.8,2.5,2.5l0,0c0,1.7-0.8,2.5-2.5,2.5H4.6c-1.7,0-2.5-0.8-2.5-2.5l0,0\n\tC2.1,41.2,3,40.3,4.6,40.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/system.svg
// module id = Jax1
// module chunks = 59